/** Month numbers (1 = January, 7 = July) when tour dates are unavailable — every year. */
export const TOUR_BLOCKED_MONTHS = [7];

export const TOUR_BOOKING_BUFFER_BUSINESS_DAYS = 3;

export const TOUR_SEASONAL_NOTICE_MESSAGE =
  'Building tours are not available in July (annual maintenance). For help, contact our Executive Director,';

export const TOUR_CONTACT_NAME = 'Monica Davis';

export const TOUR_CONTACT_EMAIL = 'mdavis@jhu.edu';

export const TOUR_JULY_UNAVAILABLE_MESSAGE = `${TOUR_SEASONAL_NOTICE_MESSAGE} ${TOUR_CONTACT_NAME}, at ${TOUR_CONTACT_EMAIL}.`;

/** Shown only on submit validation — full July notice lives in the yellow banner. */
export const TOUR_BLOCKED_DATE_VALIDATION_MESSAGE =
  'July is not available for tours. Please choose another month.';
